<template>
  <div class="mobile-container">
    <!-- 筛选栏 -->
    <div class="filter-bar" style="position: relative; z-index: 50;">
      <el-text class="pay-text">欢迎购物</el-text>
      <el-select placeholder="排序" v-model="selectedSort" style="width: 240px">
        <el-option label="默认排序" value="default"></el-option>
        <el-option label="价格从低到高" value="priceAsc"></el-option>
        <el-option label="价格从高到低" value="priceDesc"></el-option>
        <el-option label="销量优先" value="sales"></el-option>
      </el-select>
    </div>

    <!-- 黄金梨商品列表 -->
    <div class="product-grid">
      <div
          v-for="product in filteredProducts"
          :key="product.id"
          class="product-card"
      >
        <!-- 商品图片（替换为黄金梨真实图片） -->
        <div class="product-img">
          <el-image
              :src="product.imageUrl"
              fit="cover"
              :preview-src-list="[product.imageUrl]"
              class="product-image"
              lazy
          >
            <template #error>
              <div class="image-fallback">
                <el-icon class="fallback-icon">
                  <Fruits/>
                </el-icon>
                <span>图片加载失败</span>
              </div>
            </template>
          </el-image>
          <!-- 销量标签 -->
          <div class="sales-tag" v-if="product.sales > 0">
            已售 {{ product.sales }}
          </div>
          <!-- 黄金梨专属标签 -->
          <div class="pear-tag">黄金梨专属</div>
        </div>

        <!-- 商品信息 -->
        <div class="product-info">
          <h3 class="product-name">{{ product.name }}</h3>
          <div class="product-price">
            <span class="current-price">¥{{ product.price.toFixed(2) }}</span>
            <span class="original-price" v-if="product.originalPrice">¥{{ product.originalPrice.toFixed(2) }}</span>
          </div>
          <div class="product-desc">{{ product.desc }}</div>
        </div>

        <!-- 底部操作按钮-->
        <div class="product-actions">
          <el-button
              size="mini"
              type="default"
              class="add-cart-btn"
              @click="handleAddCart(product)"
          >
            <el-icon class="cart-icon">
              <ShoppingCart/>
            </el-icon>
            加入购物车
          </el-button>
          <el-button
              size="mini"
              type="primary"
              class="buy-now-btn"
              @click="handleBuyNow(product)"
          >
            立即购买
          </el-button>
        </div>
      </div>
    </div>
    <!-- 无数据提示 -->
    <div class="empty-tip" v-if="filteredProducts.length === 0">
      暂无匹配的黄金梨商品
    </div>
    <div class="bottom-null">
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import {Fruits, ShoppingCart} from '@element-plus/icons-vue';
import order1 from '@/resource/order1.jpg'
import order2 from '@/resource/order2.jpg'
import order3 from '@/resource/order3.jpg'
import order4 from '@/resource/order4.jpg'
/*import order5 from '@/resource/order5.jpg'*/
import order6 from '@/resource/order6.jpg'
import order8 from '@/resource/order8.jpg'
import {ElNotification} from "element-plus";
// 黄金梨真实商品图片（替换为可访问的黄金梨图片）
const productList = ref([
  {
    id: 2,
    name: '黄金梨礼盒装 5斤 送礼首选',
    imageUrl: order8,
    price: 69.9,
    originalPrice: 89.9,
    sales: 235,
    desc: '精美礼盒 | 大果精选 | 甜度≥15° | 顺丰包邮',
    category: 'pear'
  },
  {
    id: 1,
    name: '黄金梨调味料 调味鲜美',
    imageUrl: order3,
    price: 29.9,
    originalPrice: 39.9,
    sales: 568,
    desc: '产地直供 | 脆甜多汁 | 无农药残留 | 坏果包赔',
    category: 'pear'
  },
  {
    id: 3,
    name: '黄金梨果酱 280g*2瓶 无添加',
    imageUrl: order6,
    price: 39.9,
    originalPrice: 49.9,
    sales: 189,
    desc: '纯梨熬制 | 无蔗糖 | 早餐搭档 | 老少皆宜',
    category: 'pear'
  },
  {
    id: 4,
    name: '黄金梨干 100g*3袋 脱水锁鲜',
    imageUrl: order2,
    price: 25.9,
    originalPrice: 35.9,
    sales: 156,
    desc: '无添加防腐剂 | 酸甜可口 | 休闲零食 | 独立包装',
    category: 'pear'
  },
  {
    id: 5,
    name: '梨果沙拉 特级制作 美味减脂',
    imageUrl: order4,
    price: 39.9,
    originalPrice: 59.9,
    sales: 123,
    desc: '每份≥250g | 特级制作 | 美味减脂',
    category: 'pear'
  },
  {
    id: 6,
    name: '黄金梨汁 300ml*6盒 纯果汁',
    imageUrl: order1,
    price: 45.9,
    originalPrice: 59.9,
    sales: 98,
    desc: '100%纯梨汁 | 无添加 | NFC非浓缩还原 | 冷藏更佳',
    category: 'pear'
  }
]);

// 筛选条件
const selectedSort = ref('default');
const searchKeyword = ref('');

// 筛选后的商品列表
const filteredProducts = computed(() => {
  let result = [...productList.value];

  // 搜索筛选
  if (searchKeyword.value.trim()) {
    const keyword = searchKeyword.value.trim().toLowerCase();
    result = result.filter(
        product =>
            product.name.toLowerCase().includes(keyword) ||
            product.desc.toLowerCase().includes(keyword)
    );
  }

  // 排序处理
  switch (selectedSort.value) {
    case 'priceAsc':
      result.sort((a, b) => a.price - b.price);
      break;
    case 'priceDesc':
      result.sort((a, b) => b.price - a.price);
      break;
    case 'sales':
      result.sort((a, b) => b.sales - a.sales);
      break;
    default:
      result.sort((a, b) => a.id - b.id);
      break;
  }

  return result;
});

// 立即购买
const handleBuyNow = (product) => {
  // 直接调用 ElNotification，无需模板标签
  ElNotification({
    title: '购买提示',
    message: `即将为您购买：${product.name}`,
    type: 'success',
    duration: 2000,
    showClose: true
  });
};


// 加入购物车
const handleAddCart = (product) => {
  // 直接调用 ElNotification，无需模板标签
  ElNotification({
    title: '添加成功',
    message: `${product.name} 已加入购物车`,
    type: 'success',
    duration: 2000,
    showClose: true
  });
};

</script>

<style scoped>
/* 页面容器基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  /* 隐藏横向滚动条（防止意外横向滚动） */
  overflow-x: hidden;
  /* 可选：优化滚动体验（iOS端） */
  -webkit-overflow-scrolling: touch;
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8; /* 白色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  top: 0;
  left: 0;
}

.pay-text {
  font-weight: bold; /* 加粗 */
  margin-top: -5px;
  margin-right: 30px;
  font-size: 24px;
}

/* 筛选栏 */
.filter-bar {
  /* 核心：开启Flex布局，子元素自动横向排列 */
  display: flex;
  padding: 5px;
  background-color: #EEDC82;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平居中对齐 */
  /*border-radius: 8px;
   margin-bottom: 16px;
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;*/
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* 下拉框弹窗样式（解决错位） */
:deep(.sort-popper) {
  top: 40px !important;
  left: 0 !important;
  width: 100% !important;
  min-width: unset !important;
}

/* 搜索框样式 */
.search-input {
  width: 100%;
  height: 34px;
  border-radius: 6px !important;
}

.search-btn {
  background-color: #ffb800 !important;
  border-color: #ffb800 !important;
  color: #fff !important;
}

/* 商品网格布局 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5px;
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
}

/* 商品卡片 */
.product-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 商品图片容器 */
.product-img {
  position: relative;
  padding-top: 100%; /* 1:1比例 */
}

.product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 图片加载失败 */
.image-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #faf6ed;
  color: #999;
  font-size: 12px;
}

.fallback-icon {
  font-size: 24px;
  color: #ffb800;
  margin-bottom: 8px;
}

/* 标签样式 */
.sales-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(255, 59, 48, 0.8);
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 12px;
  z-index: 1;
}

.pear-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(255, 184, 0, 0.9);
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 12px;
  z-index: 1;
}

/* 商品信息 */
.product-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.product-price {
  display: flex;
  align-items: baseline;
  margin-bottom: 6px;
}

.current-price {
  font-size: 16px;
  font-weight: 600;
  color: #ff3b30;
  margin-right: 6px;
}

.original-price {
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
}

.product-desc {
  font-size: 11px;
  color: #888;
  margin-top: auto;
  line-height: 1.3;
}

/* 操作按钮 */
.product-actions {
  display: flex;
  padding: 3px 5px;
  border-top: 1px solid #f5f5f5;
}

.add-cart-btn {
  flex: 1;
  color: #ffb800 !important;
  border: 1px solid #ffb800 !important;
  border-radius: 4px !important;
  background-color: #fff !important;
  height: 40px !important;
  width: 65px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-icon {
  margin-right: 2px;
  font-size: 14px;
}

.buy-now-btn {
  flex: 1;
  background-color: #ffb800 !important;
  border-color: #ffb800 !important;
  border-radius: 4px !important;
  color: #fff !important;
  height: 40px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 无数据提示 */
.empty-tip {
  margin-top: 60px;
}

.bottom-null {
  height: 1vh;
}

/* 适配小屏幕 */
@media screen and (max-width: 375px) {
  .product-name {
    font-size: 13px;
  }

  .current-price {
    font-size: 15px;
  }

  .add-cart-btn,
  .buy-now-btn {
    font-size: 11px !important;
  }
}
</style>